// Copied from `config.scss`
var TOP_BAR_HEIGHT_DEFAULT = 56;
function calculateIframeHeight() {
    return heightToPx(window.innerHeight);
}
function getTopBarHeight() {
    var element = document.getElementById('content');
    var cssValue = getComputedStyle(element).getPropertyValue('padding-top');
    return parseInt(cssValue, 10) || TOP_BAR_HEIGHT_DEFAULT;
}
function heightToPx(height) {
    var topBarHeight = getTopBarHeight();
    return height - topBarHeight + "px";
}

export { TOP_BAR_HEIGHT_DEFAULT, calculateIframeHeight, getTopBarHeight, heightToPx };
